import React from "react";
import { Navigate } from "react-router-dom";
import { isTokenExpired, logoutUser } from "./auth";

const ProtectedRoute = ({ children, permission }) => {
    const token = localStorage.getItem("token");
    const roles = (JSON.parse(localStorage.getItem("roles")) || [])
        .map(role => role.trim());

    
    if (!token) {
        return <Navigate to="/login" replace />;
    }

    //  TOKEN EXPIRED → clear & redirect to login
    if (isTokenExpired(token)) {
        logoutUser();
        // return null;
            return <Navigate to="/login" replace />;

    }

    // PERMISSION CHECK → redirect to dashboard if no permission
    if (permission && !roles.includes(permission.trim())) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default ProtectedRoute;